import EmblaCarousel from 'embla-carousel';
import { refs, domReady } from '../modules/utils.js';

class EventCarousel extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#initEmbla();
    this.#listeners();
  }

  disconnectedCallback() {
    this.embla?.destroy();
  }

  #initEmbla() {
    if (!this.refs.viewport) return;

    this.embla = EmblaCarousel(this.refs.viewport, {
      align: 'start',
      loop: false,
      dragFree: false,
    });

    this.embla.on('select', () => this.#updateDots());
    this.embla.on('reInit', () => this.#updateDots());
    this.#updateDots();
  }

  #listeners() {
    this.#dots.forEach((dot) => {
      dot.addEventListener('pointerup', () => {
        this.embla?.scrollTo(parseInt(dot.dataset.index, 10));
      });
    });
  }

  #updateDots() {
    if (!this.embla) return;

    const selected = this.embla.selectedScrollSnap();
    this.#dots.forEach((dot, index) => {
      dot.toggleAttribute('data-active', index === selected);
    });
  }

  get #dots() {
    const dots = this.refs.dot;
    if (!dots) return [];
    return Array.isArray(dots) ? dots : [dots];
  }
}

customElements.define('event-carousel', EventCarousel);
